import { BlankEditorDoTest } from '@doltech/ui/lib/figma/BlankEditor/DoTest/BlankEditorDoTest';
import { CircleText, QuestionDisplayMode } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { SingleAnswerMain } from '../../../student-do-test-questions/SingleAnswer';
import { DoTestSentenceCompleteQuestionInstance } from '../../../student-do-test/model/Question/do-test-sentence-complete-question.store';

export interface SentenceCompleteSubjectProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestSentenceCompleteQuestionInstance;
}

const Main = styled(SingleAnswerMain).withConfig({
  componentId: 'SentenceCompletionSubject_Main',
} as any)`
  display: grid;
  gap: 20px;
`;

const QuestionWrapper = styled.div.withConfig({
  componentId: 'SentenceCompletionSubject_QuestionWrapper',
} as any)`
  display: flex;
  .question-no,
  .blank {
    display: inline-block;
  }
`;

export const SentenceCompleteSubject = observer((props: SentenceCompleteSubjectProps) => {
  const {
    data: { no, sentences },
    ...rest
  } = props;

  return (
    <Main className="dol-question sentence-completion-answer" {...rest}>
      {sentences.map((sentence, index) => (
        <QuestionWrapper key={sentence.id}>
          <CircleText
            displayMode={QuestionDisplayMode.QUESTION_NO_VIEW_SUBJECT}
            circleText={no + index}
            text={null}
            className="question-no"
          />
          <span className="blank">
            <BlankEditorDoTest
              editorValue={sentence.editorValueJS}
              no={no}
              blanks={sentence.blanks as any[]}
              showQuestionNo={false}
            />
          </span>
        </QuestionWrapper>
      ))}
    </Main>
  );
});
